import Vue from 'vue';
import Vuex from 'vuex';
import agentStore from './modules/agentStore';
import leadsListStore from './modules/leadsListStore';
import premierLeadsListStore from './modules/premierLeadsListStore';
import leadAgentMappingStore from './modules/leadStore';
import experimentStore from './modules/experimentStore';
import userStore from './modules/userStore';
import principalStore from './modules/principalStore';
import prospectsStore from './modules/prospectsStore';
import prospectStore from './modules/prospectStore';
import bannerStore from './modules/bannerStore';
import caseStore from './modules/caseStore';

Vue.use(Vuex);

export default function makeStore(apiServices) {
  return new Vuex.Store({
    modules: {
      agentStore: agentStore(apiServices),
      leadAgentMappingStore: leadAgentMappingStore(apiServices),
      leadsListStore: leadsListStore(apiServices),
      premierLeadsListStore: premierLeadsListStore(apiServices),
      experimentStore: experimentStore(apiServices),
      userStore: userStore(apiServices),
      principalStore: principalStore(apiServices),
      prospectsStore: prospectsStore(apiServices),
      prospectStore: prospectStore(apiServices),
      bannerStore: bannerStore(apiServices),
      caseStore: caseStore(apiServices),
    },
  });
}
